"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
var initializeSignatureContent_1 = require("../actions/initializeSignatureContent");
var store_1 = require("../store/store");
var owa_session_store_1 = require("owa-session-store");
// import strings from 'owa-strings/owa-options-strings';
var React = require("react");
var react_1 = require("satcheljs/lib/legacy/react");
var owa_editor_1 = require("owa-editor");
var mobx_1 = require("mobx");
var owa_editor_ribbonplugin_1 = require("owa-editor-ribbonplugin");
var Spinner_1 = require("office-ui-fabric-react/lib/Spinner");
var styles = require('./SignatureOption.scss');
var SignatureEditor = /** @class */ (function (_super) {
    tslib_1.__extends(SignatureEditor, _super);
    function SignatureEditor(props) {
        var _this = _super.call(this, props) || this;
        _this.ribbonPlugin = new owa_editor_ribbonplugin_1.LazyRibbonPluginClass(_this.props.optionStore.ribbon, _this.props.optionStore.editorViewState);
        return _this;
    }
    SignatureEditor.prototype.componentDidMount = function () {
        initializeSignatureContent_1.default();
    };
    SignatureEditor.prototype.render = function () {
        var _a = this.props, optionStore = _a.optionStore, isRtl = _a.isRtl;
        return (React.createElement("div", { className: styles.editorContainer }, this.isMessageOptionsFetchComplete ? ([
            React.createElement(owa_editor_ribbonplugin_1.Ribbon, { key: "ribbon", ribbonPlugin: this.ribbonPlugin, viewState: optionStore.ribbon, className: styles.ribbon }),
            React.createElement(owa_editor_1.ReactEditor, { key: "editor", isRtl: isRtl, viewState: optionStore.editorViewState, plugins: this.plugins, classNames: styles.editor, updateOnKeyPress: true }),
        ]) : (React.createElement("div", { className: styles.loading },
            React.createElement(Spinner_1.Spinner, { size: Spinner_1.SpinnerSize.medium })))));
    };
    Object.defineProperty(SignatureEditor.prototype, "plugins", {
        get: function () {
            // VSO 14829 - Use a common collection of plugins
            return [this.ribbonPlugin];
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(SignatureEditor.prototype, "isMessageOptionsFetchComplete", {
        get: function () {
            var optionStore = this.props.optionStore;
            return optionStore.editorViewState.content !== null;
        },
        enumerable: true,
        configurable: true
    });
    tslib_1.__decorate([
        mobx_1.computed
    ], SignatureEditor.prototype, "isMessageOptionsFetchComplete", null);
    SignatureEditor = tslib_1.__decorate([
        react_1.reactive({
            optionStore: function () { return store_1.default; },
            userOptions: function () { return owa_session_store_1.getUserConfiguration().UserOptions; },
            isRtl: function () { return owa_session_store_1.getUserConfiguration().SessionSettings.IsUserCultureRightToLeft; },
        })
    ], SignatureEditor);
    return SignatureEditor;
}(React.Component));
exports.default = SignatureEditor;
//# sourceMappingURL=SignatureEditor.js.map


//////////////////
// WEBPACK FOOTER
// ./obj/options/config/mail/owa-signature-option/lib/components/SignatureEditor.js
// module id = 5007
// module chunks = 2